'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function AmindShare(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M864 608a32 32 0 0 1 64 0v224a64 64 0 0 1-64 64H160a64 64 0 0 1-64-64V288a64 64 0 0 1 64-64h352a32 32 0 0 1 0 64H192a32 32 0 0 0-32 32v480a32 32 0 0 0 32 32h640a32 32 0 0 0 32-32v-192zM809.984 265.12L684.16 177.664a29.632 29.632 0 0 1-7.36-41.44 30.144 30.144 0 0 1 41.792-7.328l196.608 136.64a29.632 29.632 0 0 1 7.36 41.44l-137.664 195.136a30.144 30.144 0 0 1-41.792 7.296 29.632 29.632 0 0 1-7.36-41.472l103.456-146.592c-195.84 20.64-348.384 185.088-348.384 384.896 0 16.416-13.44 29.76-30.016 29.76a29.888 29.888 0 0 1-30.016-29.76c0-222.72 164.32-407.392 379.2-441.12z' })
  );
}
AmindShare.displayName = 'AmindShare';

module.exports = AmindShare;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/amindShare.js
// module id = 145
// module chunks = 0